import React from 'react';
import Icon from '@xo-union/tk-component-icons';
import ErrorToast from '../../../component-error-toast';
import styles from './toast.scss';

const ToastTypeSuccess = 'Success';
const ToastTypeError = 'Error';
const ToastTypeWarning = 'Warning';
interface Props {
  show: boolean | undefined;
  message: string | null | undefined;
  type: string | null | undefined;
}

const Toast: React.FC<Props> = ({ message, type, show }) => {
  let classNames = `${styles.alert} ${show ? styles.visible : ''}`;
  let textClassName = `${styles.toastContainer}`;
  let icon;
  if (type === ToastTypeSuccess) {
    classNames += ` ${styles.successToast}`;
    icon = <Icon name="checkmark_circle" size="md" />;
  } else if (type === ToastTypeError) {
    icon = <Icon name="error" size="md" />;
  } else if (type === ToastTypeWarning) {
    classNames = styles.warningToast;
    textClassName = styles.warningText;
    icon = <Icon name="warning" size="md" />;
  }

  return (
    <ErrorToast className={classNames}>
      <div data-testid="rsvp-settings-toast" className={textClassName}>
        {icon}
        <div className={styles.messageContainer}>{message}</div>
      </div>
    </ErrorToast>
  );
};

export default Toast;
export { ToastTypeError, ToastTypeSuccess };
